module.exports = __webpack_public_path__ + "img/diff-3-v2.02bbca56.png";